module.exports = __webpack_public_path__ + "img/icon-self-title.133d81bd.png";